import { Button } from '@mui/material';
import styles from './notFound.module.css';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';


export default function NotFound() {

  const navigateTo = useNavigate();

  return (
    <>
      <Helmet>
        <title>صفحه مورد نظر یافت نشد - نوآوران پژوه</title>
      </Helmet>
      <main className={styles.main}>
        <div className={styles.error_container}>
          <p dir='ltr' className="display-4 fw-bolder h1">404</p>
          <img className='w-100' src="/assets/images/notFound/404.png" alt="not Found" />
          <p className="mb-4">صفحه مورد نظر یافت نشد !</p>
          <div className={`${styles.errorActions} d-flex flex-wrap gap-4 justify-content-center`}>
            <Button onClick={() => navigateTo('/')} variant='contained' color='primary'>بازگشت به خانه</Button>
            <Button onClick={() => navigateTo('/contactUs')} variant='outlined' color='primary'>تماس با پشتیبانی</Button>
          </div>
        </div>
      </main >
    </>
  )
}
